module.exports = __webpack_public_path__ + "img/na.f33a3141.svg";